import React from 'react';
import { connect } from 'react-redux';
import { availableMerklistenCountSelector } from '../../../modules/selectors/merkliste';
import StandortLink from '../../components/VHost/StandortLink';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { fetchMerklistenProductsIfNeeded } from '../../../modules/actions/merkliste';
import { frontloadConnect } from 'react-frontload';
import { userSelector } from '../../../modules/selectors/auth';

const MerklistenLink = ({ merklisteCount }) => {
    const ariaLabel =
      merklisteCount === 0
        ? 'Merkliste'
        : merklisteCount === 1
          ? 'Merkliste, 1 Produkt'
          : `Merkliste, ${merklisteCount} Produkte`;

    return (
        <StandortLink to="/merkliste" ariaLabel={ariaLabel} className="focus">
            <div className="uk-position-relative">
                <span data-uk-icon="icon: heart; ratio: 1.5" aria-hidden="true"/>
                {merklisteCount > 0 &&
                    <div className="uk-badge uk-position-absolute" style={{ height: 20, minWidth: 20, top: -8, right: -8 }} aria-hidden="true">
                        {merklisteCount}
                    </div>
                }
            </div>
        </StandortLink>
    );
};

const frontload = async props => {
    await Promise.all([props.fetchMerklistenProductsIfNeeded()]);
};

const mapStateToProps = state => {
    return {
        merklisteCount: availableMerklistenCountSelector(state),
        markenStandort: markenStandortSelector(state),
        user: userSelector(state),
    };
};

const mapDispatchToProps = { fetchMerklistenProductsIfNeeded };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(frontloadConnect(frontload, { onUpdate: true, noServerRender: true })(MerklistenLink));
